var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("validation-observer", {
            ref: "validator",
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var valid = ref.valid
                    return [
                      _c(
                        "b-form",
                        {
                          class: [_vm.inline ? "gap-2 items-center" : ""],
                          attrs: { inline: _vm.inline },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.createOrUpdate.apply(null, arguments)
                            },
                            reset: function ($event) {
                              $event.preventDefault()
                              return _vm.clearForm.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("validation-provider", {
                            staticClass: "flex-grow",
                            attrs: {
                              name: "name",
                              rules: "required",
                              slim: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (validationContext) {
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          class: [
                                            _vm.inline
                                              ? "flex-col items-start pb-1 inline-input-group"
                                              : "",
                                          ],
                                          attrs: {
                                            id: "input-group-1",
                                            label: _vm.$t("modality.name"),
                                            "label-for": "name",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "pr-0 w-full",
                                            attrs: {
                                              id: "name",
                                              type: "text",
                                              state:
                                                _vm.getValidationState(
                                                  validationContext
                                                ),
                                            },
                                            model: {
                                              value: _vm.model.name,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.model, "name", $$v)
                                              },
                                              expression: "model.name",
                                            },
                                          }),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              class: [{ absolute: _vm.inline }],
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    validationContext.errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("validation-provider", {
                            staticClass: "flex-grow",
                            attrs: {
                              name: "description",
                              rules: "max:128",
                              slim: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (validationContext) {
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          class: [
                                            _vm.inline
                                              ? "flex-col items-start pb-1 inline-input-group"
                                              : "",
                                          ],
                                          attrs: {
                                            label: _vm.$t(
                                              "modality.description"
                                            ),
                                            "label-for": "description",
                                          },
                                        },
                                        [
                                          _c("b-form-textarea", {
                                            staticClass: "pr-0 w-full",
                                            attrs: {
                                              id: "description",
                                              rows: "3",
                                              "max-rows": "6",
                                              state:
                                                _vm.getValidationState(
                                                  validationContext
                                                ),
                                            },
                                            model: {
                                              value: _vm.model.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression: "model.description",
                                            },
                                          }),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              class: [{ absolute: _vm.inline }],
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    validationContext.errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm.id
                            ? _c(
                                "b-form-row",
                                {
                                  class: [
                                    "justify-center",
                                    _vm.inline ? "ml-auto" : "",
                                  ],
                                },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "w-full text-left block",
                                        },
                                        [_vm._v(" Logo ")]
                                      ),
                                      _c("image-upload", {
                                        key: _vm.logoUploadURL,
                                        staticClass:
                                          "border-faint-grey border-solid border p-2 rounded-lg",
                                        attrs: {
                                          maxHeight: "100px",
                                          maxWidth: "200px",
                                          uploadUrl: _vm.logoUploadURL,
                                        },
                                        on: {
                                          "upload-complete":
                                            _vm.uploadLogoSuccess,
                                        },
                                        model: {
                                          value: _vm.imageData,
                                          callback: function ($$v) {
                                            _vm.imageData = $$v
                                          },
                                          expression: "imageData",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "b-form-row",
                            {
                              class: [
                                "justify-end mt-2",
                                _vm.inline ? "ml-auto" : "",
                              ],
                            },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        disabled: !valid,
                                        type: "submit",
                                        variant: "primary",
                                      },
                                    },
                                    [
                                      _vm._t("submit-button-text", function () {
                                        return [_vm._v("Salvar")]
                                      }),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "reset",
                                        variant: "outline-secondary",
                                      },
                                    },
                                    [
                                      _vm._t("reset-button-text", function () {
                                        return [_vm._v("Limpar")]
                                      }),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "float-right",
                                      attrs: { variant: "outline-secondary" },
                                      on: { click: _vm.goBack },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "CornerUpLeftIcon" },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "align-middle" },
                                        [_vm._v(_vm._s(_vm.$t("back")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }